/*const ApiRootUrl ='http://innoapi.tian-power.cn:8918/api/v1/';
const ApiFileUrl ='http://innoapi.tian-power.cn:8918/';*/
/*const ApiRootUrl ='http://14.116.147.6:8918/api/v1/';
const ApiFileUrl ='http://14.116.147.6:8918/';*/

const ApiRootUrl = 'http://eb.tpaicloud.com:8918/api/v1/'
const ApiFileUrl = 'http://eb.tpaicloud.com:8918/'
// const ApiRootUrl = 'http://120.234.27.130:9004/api/v1/'
// const ApiFileUrl = 'http://120.234.27.130:9004/'


/*const ApiRootUrl ='http://192.168.31.83:8801/api/v1/';
const ApiFileUrl ='http://192.168.31.83:8801/';*/
/*const ApiRootUrl ='http://192.168.3.82:8801/api/v1/';
const ApiFileUrl ='http://192.168.3.82:8801/';*/
/*const ApiRootUrl ='https://api.jingnoo.top/api/v1/';
const ApiFileUrl ='https://api.jingnoo.top/';*/
/*const ApiRootUrl ='http://192.168.3.12:8088/api/v1/';
const ApiFileUrl ='http://192.168.3.12:8088/';*/
/*const ApiRootUrl ='http://192.168.1.6:8088/api/v1/';
const ApiFileUrl ='http://192.168.1.6:8088/';*/
const ApiUrl = {
    
    'config': ApiRootUrl + 'config',
    'i18nlist': ApiRootUrl + 'i18nlist',
    'langtype': ApiRootUrl + 'langtype',
    'langtypeitem': ApiRootUrl + 'systemlang/langtypeitem',
    'addlangtype': ApiRootUrl + 'systemlang/langtypeadd',
    'editlangtype': ApiRootUrl + 'systemlang/langtypeedit',
    'deletelangtype': ApiRootUrl + 'systemlang/langtypedelete',
    'lang': ApiRootUrl + 'lang',
    'langlist': ApiRootUrl + 'systemlang/langlist',
    'addlang': ApiRootUrl + 'systemlang/langadd',
    'editlang': ApiRootUrl + 'systemlang/langedit',
    'deletelang': ApiRootUrl + 'systemlang/langdelete',
    'captchaInfo': ApiRootUrl + 'login/captchaInfo',
    'login': ApiRootUrl + 'user/login',
    'usermenulist': ApiRootUrl + 'user/menulist',
    'homelist': ApiRootUrl + 'home/list',
    'menuList': ApiRootUrl + 'menu/menulist',
    'menuoptionslist': ApiRootUrl + 'menu/menuoptionslist',
    'menualloptionslist': ApiRootUrl + 'menu/menualloptionslist',
    'addmenu': ApiRootUrl + 'menu/addmenu',
    'editmenu': ApiRootUrl + 'menu/editmenu',
    'menuitem': ApiRootUrl + 'menu/menuitem',
    'deletemenu': ApiRootUrl + 'menu/deletemenu',
    'devicetypelist': ApiRootUrl + 'devicetype/list',
    'devicetypeitem': ApiRootUrl + 'devicetype/item',
    'adddevicetype': ApiRootUrl + 'devicetype/addtype',
    'editdevicetype': ApiRootUrl + 'devicetype/edittype',
    'deletedevicetype': ApiRootUrl + 'devicetype/deletetype',
    'devicetypeoptionslist': ApiRootUrl + 'devicetype/typeoptionslist',
    'adddevicetypesetparam': ApiRootUrl + 'devicetype/addsetparam',
    'devicetypesetparam': ApiRootUrl + 'devicetype/setparam',
    'adddevicetypesetalarm': ApiRootUrl + 'devicetype/addsetalarm',
    'devicetypesetalarm': ApiRootUrl + 'devicetype/setalarm',
    'devicetypeuploadimg': ApiRootUrl + 'devicetype/uploadimg',
    'projectlist': ApiRootUrl + 'project/list',
    'projectalllist': ApiRootUrl + 'project/alllist',
    'addproject': ApiRootUrl + 'project/addproject',
    'editproject': ApiRootUrl + 'project/editproject',
    'deleteproject': ApiRootUrl + 'project/deleteproject',
    'adddevice': ApiRootUrl + 'device/add',
    'editdevice': ApiRootUrl + 'device/edit',
    'setfence': ApiRootUrl + 'device/setfence',
    'setrefence': ApiRootUrl + 'device/setrefence',
    'setclosefence': ApiRootUrl + 'device/setclosefence',
    'devicelist': ApiRootUrl + 'device/list',
    // 设备列表
    'newdevicelist': ApiRootUrl + 'device/btlist',
    'devicemaplist': ApiRootUrl + 'device/maplist',
    'chargeCapacity': ApiRootUrl + 'device/quantityofelectricity',
    'deletedevice': ApiRootUrl + 'device/delete',
    'devicebasicdetails': ApiRootUrl + 'device/basicdetails',
    'devicehistoricallist': ApiRootUrl + 'device/historicallist',
    'deviceallhistoricallist': ApiRootUrl + 'device/allhistoricallist',
    'devicealarmlist': ApiRootUrl + 'device/alarmlist',
    'devicesetparamlist': ApiRootUrl + 'device/setparamlist',
    'devicebasic': ApiRootUrl + 'device/basic',
    'devicebasicalarm': ApiRootUrl + 'device/basicalarm',
    'devicebasicparam': ApiRootUrl + 'device/basicparam',
    'devicehistorical': ApiRootUrl + 'device/devicehistoricallist',
    'deletedevicehistorical': ApiRootUrl + 'device/deletehistorical',
    'deletedevicealarm': ApiRootUrl + 'device/deletealarm',
    'devicelocus': ApiRootUrl + 'device/locus',
    'devicehistoricallisttoecharts': ApiRootUrl + 'device/devicehistoricallisttoecharts',
    'userlist': ApiRootUrl + 'user/list',
    'userdevicetypelist': ApiRootUrl + 'user/devicetypelist',
    'userprojectlist': ApiRootUrl + 'user/projectlist',
    'adduser': ApiRootUrl + 'user/add',
    'edituser': ApiRootUrl + 'user/edit',
    'useritem': ApiRootUrl + 'user/item',
    'deleteuser': ApiRootUrl + 'user/delete',
    'userrepassword': ApiRootUrl + 'user/repassword',
    'logslist': ApiRootUrl + 'logs/list',
    'upgradelist': ApiRootUrl + 'upgrade/list',
    'addupgrade': ApiRootUrl + 'upgrade/add',
    'editupgrade': ApiRootUrl + 'upgrade/edit',
    'deleteupgrade': ApiRootUrl + 'upgrade/delete',
    'upgradeuploadfile': ApiRootUrl + 'upgrade/uploadfile',
    'externallist': ApiRootUrl + 'external/list',
    'setexternalupgrade': ApiRootUrl + 'external/setupgrade',
    'upgradedevicelist': ApiRootUrl + 'upgrade/devicelist',
    'externaliccidlist': ApiRootUrl + 'external/iccidlist',
    'setdeviceupgrade': ApiRootUrl + 'upgrade/setdeviceupgrade',
    'closeexternalupgrade': ApiRootUrl + 'external/closeupgrade',
    'closedeviceupgrade': ApiRootUrl + 'upgrade/closedeviceupgrade',
    'runalarmlist': ApiRootUrl + 'runalarm/list',
    'translation': ApiRootUrl + 'translation',
    'projectsetprohibited': ApiRootUrl + 'project/projectsetprohibited',
    'getdevicesubnum': ApiRootUrl + 'device/subnum',
    'statisiticsnum': ApiRootUrl + 'home/statisiticsnum',
    'editdevicelistproject': ApiRootUrl + 'device/editdevicelistproject',
    'upgradeUserids': ApiRootUrl + 'upgrade/userids',
    'upgradeSetuserids': ApiRootUrl + 'upgrade/setuserids',
    'provincecityList': ApiRootUrl + 'provincecity/alllist',
    'provincecityDevicelist': ApiRootUrl + 'provincecity/devicelist',
    'statisticstodayupgradenum': ApiRootUrl + 'upgrade/statisticstodayupgradenum',
    'getstatisticsupgradenumlist': ApiRootUrl + 'upgrade/getstatisticsupgradenumlist',
    'statisticsSurplusUpgradeNum': ApiRootUrl + 'upgrade/statisticsSurplusUpgradeNum',
    //ICCID号段所属终端客户
    'batteryIccidlist': ApiRootUrl + 'battery/iccidlist',
    'batteryIcciditem': ApiRootUrl + 'battery/icciditem',
    'batteryAddiccid': ApiRootUrl + 'battery/addiccid',
    'batteryEditiccid': ApiRootUrl + 'battery/editiccid',
    'batteryDeleteiccid': ApiRootUrl + 'battery/deleteiccid',
    'batteryIccidoptionslist': ApiRootUrl + 'battery/iccidoptionslist',
    //域名规则
    'batteryUrlruleslist': ApiRootUrl + 'battery/urlruleslist',
    'batteryUrlrulesitme': ApiRootUrl + 'battery/urlrulesitme',
    'batteryAddurlrules': ApiRootUrl + 'battery/addurlrules',
    'batteryEditurlrules': ApiRootUrl + 'battery/editurlrules',
    'batteryDeleteurlrules': ApiRootUrl + 'battery/deleteurlrules',
    //ip规则
    'batteryUrlrulesIPlist': ApiRootUrl + 'battery/ipruleslist',
    'batteryUrlrulesIPitme': ApiRootUrl + 'battery/iprulesitme',
    'batteryAddurlIPrules': ApiRootUrl + 'battery/addiprules',
    'batteryEditurlIPrules': ApiRootUrl + 'battery/editiprules',
    'batteryDeleteurlIPrules': ApiRootUrl + 'battery/deleteiprules',
    // 电池SN规则
    'batterySnruleslist': ApiRootUrl + 'battery/snruleslist',
    'batterySnrulesitme': ApiRootUrl + 'battery/snrulesitme',
    'batteryAddsnrules': ApiRootUrl + 'battery/addsnrules',
    'batteryEditsnrules': ApiRootUrl + 'battery/editsnrules',
    'batteryDeletesnrules': ApiRootUrl + 'battery/deletesnrules',
    'homeLevelnum': ApiRootUrl + 'home/levelnum',
    'homeDevicetotals': ApiRootUrl + 'home/devicetotals',
    'homeAlarmnum': ApiRootUrl + 'home/alarmnum',

    // 关闭告警
   
    'closeAlarm': ApiRootUrl + 'runalarm/setalarmprocessed',

}
export default {
    ApiRootUrl,
    ApiUrl,
    ApiFileUrl
}



// WEBPACK FOOTER //
// ./src/config/api.js